import { render } from "./ShowMesa.vue?vue&type=template&id=c98fe1d2"
import script from "./ShowMesa.vue?vue&type=script&lang=js"
export * from "./ShowMesa.vue?vue&type=script&lang=js"

import exportComponent from "/home/u624473994/domains/backoffice.quickpay.pe/quickshop-admin-main/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__